<script setup lang="ts">
import {TestScore} from "@/types";
import {ref, watch} from "vue";

const props = defineProps<{
  optionNum: number
}>()

const scoreList = ref<OptionScore[]>([])

watch(props, () => {
      scoreList.value = []
      for (let i = 0; i <= props.optionNum; i++) {
        scoreList.value.push({
          option: i,
          score: "0.0"
        })
      }
    },
    {immediate: true}
)

type OptionScore = {
  option: number;
  score: string;
};

const mergeOptionsByScore = (options: OptionScore[]): TestScore[] => {
  const scoreMap: Map<string, number[]> = new Map();

  // 遍历原始数组，将 option 按 score 分组, 需要先处理分值的小数点部分，例如0 和 0.0需要分为同一组
  options.forEach(({option, score}) => {
    // 将 score 转换为浮点数并格式化为字符串，保留一位小数
    const formattedScore = parseFloat(score).toFixed(1);
    if (!scoreMap.has(formattedScore)) {
      scoreMap.set(formattedScore, []);
    }
    scoreMap.get(formattedScore)!.push(option);
  });

  // 将分组后的结果转换为所需的格式
  const mergedOptions: TestScore[] = [];
  scoreMap.forEach((options, score) => {
    mergedOptions.push({
      option: options.join(','),
      score: score,
    });
  });

  return mergedOptions;
};

const valid = () => {
  // 校验scoreList.value中的每个元素的score是否都有值且为数字，且数字如果为小数不得超过一位小数
  return scoreList.value.every(({score}) => {
    if (score.length === 0) {
      return false;
    }
    // 使用正则表达式验证输入是否为有效的数字，并且小数部分不超过一位
    const regex = /^\d+(\.\d)?$/;
    return regex.test(score);
  });
}

const getTestScoreList = () => {
  return mergeOptionsByScore(scoreList.value)
}

const init = (testCoreList?: string) => {
  if (testCoreList) {
    scoreList.value = []
    const mergedOptions: TestScore[] = JSON.parse(testCoreList)
    console.log(mergedOptions)
    for (let i = 0; i < mergedOptions.length; i++) {
      const {option, score} = mergedOptions[i];
      const optionList = option.split(",")
      for (let j = 0; j < optionList.length; j++) {
        scoreList.value.push({
          option: parseInt(optionList[j]),
          score: score
        })
      }
    }
    console.log(scoreList.value)
  }
}

defineExpose({
  init, valid, getTestScoreList
})
</script>

<template>
  <div class="flex gap-.5rem flex-wrap">
    <div v-for="item in scoreList">
      <el-input v-model="item.score">
        <template #prepend>
          {{ `答对${item.option}个，得分` }}
        </template>
      </el-input>
    </div>
  </div>
</template>

<style scoped>
</style>
